import { useEffect, useState } from "react";
import AchievementsComponent from "../../components/achievements/achievements";
import Ranking from "../../components/ranking/ranking";
import Features from "../../enums/features";
import { isFeatureEnabledForBranch } from "../../apis/featureApi";
import HowItWorks from "../../components/howItWorks/HowItWorks";

const Achievements = () => {
  const [isAchievementsEnabled, setIsAchievementsEnabled] = useState(false);
  const [isRankingEnabled, setIsRankingEnabled] = useState(false);
  
    useEffect(() => {
      async function checkFeatures() {
          const achievementsEnabled = await isFeatureEnabledForBranch(Features.ACHIEVEMENTS)
          setIsAchievementsEnabled(achievementsEnabled || false);
          const rankingEnabled = await isFeatureEnabledForBranch(Features.RANKING);
          setIsRankingEnabled(rankingEnabled || false);
      }
      checkFeatures();
    }, []);

  return (
    <>
      <HowItWorks title="Cómo funciona?">
        {isAchievementsEnabled && 
          <>
            <p className="font-weight-bold">Semanas Entrenadas:</p>
            <p>Si entrenas al menos una vez a la semana, desbloqueas el logro y se mostrará cuantas semanas llevas y cuanto ha sido tu máximo record</p>
          </>
        }
        <br></br>
        {isRankingEnabled &&
          <>
            <p className="font-weight-bold">Rankings:</p>
            <p>Cada vez que entrenas, se te dará un punto en los rankings, y verás tu posición en la tabla. El ranking mensual se reinicia cada mes y el ranking histórico se reinicia cada año</p>
          </>
        }
      </HowItWorks>
      {isAchievementsEnabled && <AchievementsComponent />}
      {isRankingEnabled && <Ranking />}
    </>
  );
};

export default Achievements;
